import { gql } from "@apollo/client";

export const CREATE_BLOG = gql`
  mutation createBlog($createBlogInput: CreateBlogInput!) {
    createBlog(createBlogInput: $createBlogInput) {
      id
    }
  }
`;
